var React = require('react');

function PlayButton (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M40.0002 3.89999C19.565 3.89999 2.9502 20.0888 2.9502 40C2.9502 59.9112 19.565 76.1 40.0002 76.1C60.4354 76.1 77.0502 59.9112 77.0502 40C77.0502 20.0888 60.4354 3.89999 40.0002 3.89999ZM51.935 41.8225L34.4614 53.148C32.9807 54.1366 30.9514 53.0708 30.9514 51.3252V28.6765C30.9514 26.9278 32.9807 25.8651 34.4614 26.8537L51.9319 38.1761C53.2603 39.0104 53.2603 40.9875 51.9349 41.8218L51.935 41.8225Z","fill":"white"}));
}

PlayButton.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = PlayButton;

PlayButton.default = PlayButton;
